import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeBroadcastService {
  private channel: BroadcastChannel | null = null;
  private themeSubject: Subject<{ type: string, value: string }> = new Subject();
  private channelKey: string = 'user_theme';  // Canal específico para los cambios de tema

  constructor() {
    // Si el navegador soporta BroadcastChannel, creamos el canal para el tema
    if (typeof BroadcastChannel !== 'undefined') {
      this.channel = new BroadcastChannel(this.channelKey);

      // Escuchar mensajes del canal relacionados con los cambios de tema
      this.channel.onmessage = (event) => {
        if (event.data) {
          const { type, value } = event.data;
          // Si el mensaje es un cambio de tema o color, lo emitimos
          if (type === 'theme' || type === 'customColor') {
            this.themeSubject.next({ type, value });
          }
        }
      };
    } else {
      console.warn('BroadcastChannel is not supported in this browser.');
    }
  }

  // Método para enviar un cambio de tema
  sendThemeChange(theme: string): void {
    if (this.channel) {
      this.channel.postMessage({ type: 'theme', value: theme });
    }
  }

  // Método para enviar un cambio de color personalizado
  sendCustomColorChange(color: string): void {
    if (this.channel) {
      this.channel.postMessage({ type: 'customColor', value: color });
    }
  }

  // Método para recibir cambios de tema o de color
  getThemeChanges() {
    return this.themeSubject.asObservable();
  }

  // Cerrar el canal cuando el servicio ya no sea necesario
  closeChannel(): void {
    if (this.channel) {
      this.channel.close();
    }
  }
}
